import { useState } from "react";
import { Link } from "react-router-dom";
import Button from "components/Button";
import Paper from "components/Paper";
import { ReactComponent as Logo } from "assets/images/logo.svg";
import { ReactComponent as Caption } from "assets/images/caption.svg";
import { ReactComponent as HamburgerIcon } from "assets/icons/hamburger.svg";
import MenuFlyOut from "components/MenuFlyOut";

import styles from "./index.module.css";
export default function Topbar() {
    const [isMenuModalOpen, setMenuModalOpen] = useState(false);

    return (
        <div className={styles.topbar}>
            <Paper className={styles.paper}>
                <div className={styles.leftContainer}>
                    <Link to="/">
                        <Logo />
                    </Link>
                </div>
                <div className={styles.middleContainer}>
                    <Caption />
                </div>

                <div className={styles.rightContainer}>
                    <div className={styles.notificationBtn}>
                        <Button
                            variant="iconButton"
                            onClick={() => setMenuModalOpen(true)}
                            className={styles.hamburgerButton}
                        >
                            <HamburgerIcon />
                        </Button>
                        {isMenuModalOpen && (
                            <MenuFlyOut
                                isOpen={isMenuModalOpen}
                                onAttemptClose={() => setMenuModalOpen(false)}
                            />
                        )}
                    </div>
                </div>
            </Paper>
        </div>
    );
}
